<template>
    <div class="text-center mb-3">
        <h3>{{title}} <i class="icofont-list"></i></h3>
    </div>
</template>

<script>
    export default {
     name : "Title",
     props :["title"]   
    }
</script>

<style lang="scss" scoped>

</style>